import React from 'react';

const Footer = () => {
	return <footer>Copyright {new Date().getFullYear()} Grace H. J.</footer>;
};

export default Footer;
